<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">
        Editar técnico /
        <router-link to="/usuarios"
          ><a href="#">Regresar a técnicos</a>
        </router-link>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Nombre</label>
                <input
                  v-model="nombre"
                  class="form-control"
                  placeholder="Ingrese el nombre del usuario"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Apellidos</label>
                <input
                  v-model="apellidos"
                  class="form-control"
                  placeholder="Ingrese los apellidos"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Usuario</label>
                <input
                  v-model="usuario"
                  class="form-control"
                  placeholder="Asigne el usuario"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Asignar Rol</label>
                <select class="form-control" v-model="rol">
                  <option>ADMIN_MAIN</option>
                  <option>TECNICO</option>
                  <option>ANALISTA</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Contraseña</label>
                <input
                  type="password"
                  v-model="password"
                  class="form-control"
                  placeholder="Asigne la contraseña"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Repetir contraseña</label>
                <input
                  type="password"
                  v-model="retryPassword"
                  class="form-control"
                  placeholder="Repita la contraseña"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" v-if="rol != 'ADMIN_MAIN'">
                <label>Permisos</label><br />
                <md-checkbox
                  v-model="permisos.repuestos"
                  class="md-primary"
                  >Repuestos</md-checkbox
                >
                <md-checkbox
                  v-model="permisos.tarjetas"
                  class="md-primary"
                  >Tarjetas</md-checkbox
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group"></div>
            </div>
          </div>
          <button
            @click="checkForm"
            style="width: 100%;"
            class="btn btn-primary"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
export default {
  name: 'editar-usuario',
  components: {
    Loading,
  },
  props: {
    userId: Number,
  },
  data() {
    return {
      loading: true,
      nombre: '',
      apellidos: '',
      usuario: '',
      password: '',
      retryPassword: '',
      rol: '',
      permisos: {
        repuestos: false,
        tarjetas: false,
      },
    };
  },
  created() {
    this.userId = this.$router.history.current.params.userId;
    let data = {
      userId:
        this.userId || this.$router.history.current.params.userId,
    };
    ServiceApi.post('/user/detail', data)
      .then(response => {
        let data = response.data.data;
        this.nombre = data.nombre;
        this.apellidos = data.apellidos;
        this.usuario = data.usuario;
        this.rol = data.rol;
        data.permisos != null
          ? (this.permisos = JSON.parse(data.permisos))
          : '';
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
        this.$noty.error('Ocurrio un error al consultar el usuario');
        this.$router.push('/usuarios');
        this.loading = false;
      });
  },
  mounted() {},
  methods: {
    checkForm() {
      if (!this.nombre) {
        this.$noty.error('El nombre es requerido');
      } else if (!this.apellidos) {
        this.$noty.error('Los apellidos son requeridos');
      } else if (!this.usuario) {
        this.$noty.error('El usuario es requerido');
      } else if (!this.password) {
        this.$noty.error('La contraseña es requerida');
      } else if (this.password != this.retryPassword) {
        this.$noty.error('Las contraseñas no coinciden');
      } else if (!this.rol) {
        this.$noty.error('El rol es requerido');
      } else {
        this.saveInformation();
      }
    },
    saveInformation() {
      this.loading = true;
      let data = {
        userId: this.userId,
        nombre: this.nombre.toUpperCase(),
        apellidos: this.apellidos.toUpperCase(),
        usuario: this.usuario,
        password: this.password,
        rol: this.rol.toUpperCase(),
        permisos: this.permisos,
      };
      ServiceApi.post('/update/user', data)
        .then(response => {
          if (response.data.status) {
            this.$noty.success('Usuario actualizado con éxito');
            this.loading = false;
            this.$router.push('/usuarios');
          }
        })
        .catch(err => {
          console.log('EL ERROR:::', err);
          this.loading = false;
          this.$noty.error(
            'Ocurrio un error al crear el usuario, intente nuevamente o contacte el administrador'
          );
        });
    },
    onCancel() {},
  },
};
</script>
